import React, { useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setDraggingItem } from '../../../containers/planning/planningSlice';
import { addFavoriteShiftSample, deleteFavoriteShiftSample } from '../shifts/sampleShiftsSlice';
import { ShiftCell } from '../../scheduler/cells/shiftCell.js';
import styles from './Rows.module.css';

export function FavoritesRow() {

    const dispatch = useDispatch()
    const sampleShifts = useSelector((state) => state.sampleShifts.list)
    const draggingItem = useSelector((state) => state.planning.draggingItem)

    const favoriteShifts = sampleShifts.filter(s => s.is_favorite)

    const handleDragStart = (value, event) => {
        // Use the first child (ShiftCell) as drag image to avoid capturing the remove button
        const shiftCellEl = event.currentTarget.querySelector('[class*="shiftCell"]')
        if (shiftCellEl) {
            event.dataTransfer.setDragImage(shiftCellEl, 47, 27)
        }
        if (draggingItem !== value)
            dispatch(setDraggingItem(value))
    }

    const handleDragStop = (value, event) => {
        dispatch(setDraggingItem(null))
    }

    const handleDragOver = useCallback((e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "copy"
    }, [])

    const handleDrop = useCallback((e) => {
        e.preventDefault()
        // draggingItem is the shift being dragged from the samples row
        if (draggingItem && draggingItem.id && draggingItem.task && !draggingItem.is_favorite) {
            dispatch(addFavoriteShiftSample({ id_sample_shift: draggingItem.id }))
        }
    }, [draggingItem, dispatch])

    const handleRemoveFavorite = useCallback((shift, e) => {
        e.stopPropagation()
        dispatch(deleteFavoriteShiftSample({ id_sample_shift: shift.id }))
    }, [dispatch])

    return (
        <div
            className={`${styles.samplesContainer} ${styles.favoritesContainer}`}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
        >
            {favoriteShifts.length === 0 && (
                <div className={styles.favoritesPlaceholder}>
                    ★ Glissez vos shifts ici pour les ajouter aux favoris
                </div>
            )}
            {favoriteShifts.map(shift => (
                <div key={"FavShiftCell_" + shift.id}
                    draggable={true}
                    className={styles.draggableShift}
                    onDragStart={handleDragStart.bind(this, shift)}
                    onDragEnd={handleDragStop.bind(this, shift)}
                >
                    <ShiftCell data={shift} isInteractive={false} />
                    <button
                        className={styles.removeFavoriteBtn}
                        onClick={(e) => handleRemoveFavorite(shift, e)}
                        title="Retirer des favoris"
                    >
                        ✕
                    </button>
                </div>
            ))}
        </div>
    )
}